import templateUrl from '../views/modals/bulk-message-modal.tpl.html';
import ContactBulkMessageModalController from '../controllers/modals/bulk-send/contact-bulk-message-modal';

export default function contactBulkMessageModalCreator($injector, recipientsStore, extendedInformation) {
    extendedInformation = _.isObject(extendedInformation) ? extendedInformation : {};
    return $injector.get('$uibModal').open({
        controller: ContactBulkMessageModalController,
        controllerAs: 'vm',
        size: 'xlg',
        templateUrl,
        backdrop: 'static',
        windowClass: 'modal-fixed',
        keyboard: false,
        resolve: {
            extendedInformation: () => ({
                ...extendedInformation,
                recipientsStore
            })
        }
    }).result;
}



// WEBPACK FOOTER //
// ./src/app/modules/messages/helpers/contact-bulk-message-modal-creator.js